import React, { ReactElement, ReactNode, useMemo, useState } from "react";

import { ActiveClientContext } from "../context/active-client-context";

export const LOCAL_STORAGE_ACTIVE_CLIENT_ID = "activeClientId";

// Restore synchronously so the first GraphQL requests already carry the
// active-client header instead of hitting the default client.
function readStoredActiveClientId(): string | null {
  try {
    const item = window.localStorage.getItem(LOCAL_STORAGE_ACTIVE_CLIENT_ID);
    const parsed = item ? (JSON.parse(item) as unknown) : null;
    return typeof parsed === "string" && parsed ? parsed : null;
  } catch {
    return null;
  }
}

type Props = {
  children: ReactNode;
};

export default function ActiveClientProvider(props: Props): ReactElement {
  const { children } = props;
  const [activeClientId, setActiveClientId] = useState<string | null>(
    readStoredActiveClientId
  );

  const values = useMemo(
    () => ({ activeClientId, setActiveClientId }),
    [activeClientId]
  );

  return (
    <ActiveClientContext.Provider value={values}>
      {children}
    </ActiveClientContext.Provider>
  );
}
